const COUNTRIES = Object.freeze([
  { name: 'COUNTRIES:FRANCE', taxName: 'TVA', value: 'FR' },
  { name: 'COUNTRIES:ITALY', taxName: 'IVA', value: 'IT' },
]);

export type TCountryCode = 'FR' | 'IT';

export default COUNTRIES;
